import { gql } from "@apollo/client";

export const QUERY_CHARACTER_AWARENESS_DAYS_CALENDAR_PAGE = gql`
  query characterAwarenessDaysCalendarPage {
    calendarPage {
      data {
        documentId
        title
        description
        downloadButtonText
        file {
          url
        }
        calendarFeedbackMessage {
          calendarPermissionDenied
          calendarNotFound
          eventAlreadyExists
          eventAddedSuccessGoogle
          eventAddedSuccessApple
          eventAddedSuccessGeneric
        }
        NoDaysMonthText
        monthThemesTitle
      }
    }
  }
`;

export const QUERY_CALENDAR_BY_YEAR = gql`
  query calendarByYear($year: Int!) {
    calendars: calendars_connection(filters: { year: { eq: $year } }) {
      data {
        attributes {
          year
          eventDays {
            startDate
            name
            wholeMonth
            description
            endDate
            related_knowledge_base {
              data {
                attributes {
                  slug
                }
              }
            }
          }
        }
      }
    }
  }
`;
